import { codeSplit, Controller, FetchOptions } from 'bernie-core';
import { PageData } from 'bernie-http';
import { helpCenterPageIdentifier } from '../common/constant';
import PathToRegex from 'path-to-regex';
import { BASEPATH, VRBO_BASEPATH } from '../common/basepath';
// "controllers" map directly to react-router routes, can additionally provide data
export class HelpCenterController implements Controller {
  public pageId = helpCenterPageIdentifier;
  public caseSensitive = true;
  public path = `${BASEPATH}/helpcenter`;
  public routeName = 'helpcenter';
  public bundles = [];
  public component = codeSplit(() => import(/* webpackChunkName: "helpcenter" */ '../views/helpcenter'));
  public exact = true;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public fetch(options: FetchOptions): Promise<PageData> {
    const validator = new PathToRegex(`${VRBO_BASEPATH}/helpcenter`);
    if (!validator.match(options?.request?.url)) {
      options?.response?.setStatus(404);
    }
    return Promise.resolve({ title: 'Help Center', pageId: this.pageId, pageName: this.pageId });
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      title: 'Help Center',
      pageId: this.pageId,
      appName: 'Help Center',
      pageName: this.pageId,
    }) as Promise<PageData>;
  }
}
